import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
export const confirmCalEventInputSchema = z.object({
    eventId: requiredUuidString('Event is required.', 'Invalid event ID.'),
});
//# sourceMappingURL=confirm-cal-event-input.js.map